/* Màn hình lỗi của router (thay màn hình lỗi mặc định của react-router). */
import { useRouteError } from "react-router-dom"
import { Button } from "@/components/ui/button"

export function RouteError() {
  const error = useRouteError()
  console.error("Route error", error)
  return (
    <div className="grid min-h-svh place-items-center bg-sand p-6 text-center">
      <div data-route-error className="flex max-w-md flex-col items-center gap-4">
        <img src="/brand/sutucon/mascots-2d/elephant-thinking.svg" alt="" className="size-28" />
        <h1 className="text-2xl font-bold">Trang này chưa hiện được</h1>
        <p className="text-muted-foreground">Có lỗi khi vẽ trang. Con tải lại trang để thử lại nhé.</p>
        <Button onClick={() => location.reload()}>Tải lại</Button>
      </div>
    </div>
  )
}
